export const DEVELOPMENT: boolean = process.env.REACT_APP_AMBIENTE === 'desenvolvimento';
